import React, { type ComponentProps, forwardRef } from 'react';
import type { TextInstance } from 'react-native';
import { StyleSheet } from 'react-native';

import { TYPE_CONFIG, WEIGHT_MAP } from '@garnish/constants';

import { useResponsive } from '../../../hooks';
import { Text } from '../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const LabelText = forwardRef<TextInstance, LabelTextProps>((props, ref) => {
  const { children, sizeMatch = LABEL_TEXT_DEFAULT_SIZE_MATCH, bold, style, ...restProps } = props;

  const { match } = useResponsive();

  const fontSize = match(sizeMatch);
  const fontSizeStyles = LABEL_TEXT_STYLES[fontSize] ?? LABEL_TEXT_DEFAULT_FONT_STYLES;
  const boldTextStyles = bold ? styles.boldText : undefined;
  const allStyles = [fontSizeStyles, boldTextStyles, style];

  return (
    <Text ref={ref} style={allStyles} {...restProps}>
      {children}
    </Text>
  );
});

// ─── Constants ───────────────────────────────────────────────────────────────

const LABEL_TEXT_STYLES = TYPE_CONFIG.LABEL;

const LABEL_TEXT_DEFAULT_SIZE_MATCH: LabelTextFontSize[] = ['14'];
const LABEL_TEXT_DEFAULT_FONT_SIZE: LabelTextFontSize = '14';

const LABEL_TEXT_DEFAULT_FONT_STYLES = LABEL_TEXT_STYLES[LABEL_TEXT_DEFAULT_FONT_SIZE];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  boldText: {
    fontWeight: WEIGHT_MAP.bold,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LabelTextProps = Readonly<{
  sizeMatch?: LabelTextFontSize[];
}> &
  ComponentProps<typeof Text>;

type LabelTextFontSize = keyof typeof LABEL_TEXT_STYLES;
